module.exports = __webpack_public_path__ + "img/rcs.520b6245.svg";